import $ from 'jquery'
import AjaxRequest from "../modules/ajax-request";

class HeaderTags {
    constructor(element) {
        this.div = element;
        this.url = "";

        this.getData();
        this.clearData();
        this.init();
    }

    getData() {
        this.url = $(this.div).data("url");
    }

    clearData() {
        $(this.div).removeAttr("data-url");
    }

    init() {
        var _this = this;
        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_this.div).html(response.message);
            }
        });
        _ajaxRequest.makeCall(this.url);
    }
}

export default HeaderTags;